// Tunnel d'abonnement (www.pandacraft.com en prod, www.pandacraft.ninja en préprod) : CTA de formule.
// Le tunnel ignore les liens GET : au clic, la gamme et la formule sont enregistrées dans la session du site
// par un POST en arrière-plan (cookies envoyés : la boutique et le site partagent le domaine racine),
// puis le parent arrive sur /person/ avec les UTM. Sans réponse en config.funnel.timeoutMs, /person/ s'ouvre
// quand même (le parent choisira sa formule sur /plan/). Formule sans planSku => gamme seule.
// Hôte absent de config.funnel.hosts (localhost, aperçu) : aucun envoi, le clic est seulement journalisé.
//
// Balisage HTML : data-checkout="12m" (id de config.plans) -> InitiateCheckout {plan} puis tunnel.

import { track, withUtm } from "./ma-js-tracking.js?v=9dbd173928";

const PERSON = "/subscription/init_multipage/person/";

/** Tunnel de l'environnement de la page, ou null. */
function funnelBase(funnel) {
  return funnel?.hosts?.[location.hostname] || null;
}

function presetBody(plan, range, productSku) {
  const preset = plan.planSku
    ? JSON.stringify({ planSku: plan.planSku, planType: plan.planType, isPlanAutoRenewal: plan.autoRenewal })
    : "";
  return new URLSearchParams({
    subscription_preset_range_identifier: range,
    subscription_preset_product_sku: productSku || "",   // kit présélectionné (config.funnel.productSku)
    subscription_preset_plan: preset,
    subscription_funnel_product_skus: "",       // envoyé vide par la page Mission Animalia du site, idem ici
    subscription_funnel_url_origin: location.origin + location.pathname
  });
}

/** POST de présélection ; se résout toujours (réponse opaque, erreur réseau ou délai dépassé). */
function sendPreset(base, body, timeoutMs) {
  const post = fetch(`${base}/fgmd/subscription/init/?_secure=1`, {
    method: "POST", mode: "no-cors", credentials: "include", keepalive: true, body
  }).catch(() => {});
  return Promise.race([post, new Promise((done) => setTimeout(done, timeoutMs))]);
}

/** href des CTA de formule : /person/ du tunnel + UTM (ou plan.url si renseignée) ; hors boutique : inchangé. */
export function wireCheckoutLinks(config, root = document) {
  const base = funnelBase(config.funnel);
  root.querySelectorAll("[data-checkout]").forEach((a) => {
    const plan = config.plans.find((p) => p.id === a.dataset.checkout);
    const href = plan?.url || (base && base + PERSON);
    if (href) a.href = withUtm(href);
  });
}

export function initFunnel(config) {
  const base = funnelBase(config.funnel);
  let pending = null; // CTA en cours d'envoi (anti double clic)

  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-checkout]");
    if (!a) return;
    const plan = config.plans.find((p) => p.id === a.dataset.checkout);
    track("InitiateCheckout", { plan: a.dataset.checkout });
    if (!plan || plan.url) return; // lien direct : navigation normale

    const body = presetBody(plan, config.funnel.range, config.funnel.productSku);
    if (!base) {
      e.preventDefault();
      console.info("[MA funnel] hôte hors boutique : aucun envoi", Object.fromEntries(body));
      return;
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey) { // nouvel onglet : envoi sans retenir la navigation
      sendPreset(base, body, 0);
      return;
    }
    e.preventDefault();
    if (pending) return;
    pending = a;
    a.setAttribute("aria-busy", "true");
    sendPreset(base, body, config.funnel.timeoutMs).then(() => { location.href = a.href; });
  });

  // Retour arrière depuis le tunnel (cache de page) : le CTA redevient cliquable.
  window.addEventListener("pageshow", () => {
    pending?.removeAttribute("aria-busy");
    pending = null;
  });
}
